import { IMAGES } from 'common/images';
import { PERSONAS } from 'common/constants';

const TEEN_DATA = [
  { key: 'T-1', title: 'Your copy of FIFA', icon: IMAGES.Fifa },
  { key: 'T-2', title: 'Popcorn and Cola at IMAX', icon: IMAGES.Movie },
  { key: 'T-3', title: 'A large Muji notebook', icon: IMAGES.Sketchbook },
  { key: 'T-4', title: 'That clean MarchTee T-Shirt', icon: IMAGES.Shirt },
];

const PARENT_DATA = [
  { key: 'P-1', title: 'Your Netflix Subscription', icon: IMAGES.Netflix },
  { key: 'P-2', title: 'An Uber to the airport', icon: IMAGES.Uber },
  { key: 'P-3', title: 'A coffee and croissant at Starbucks', icon: IMAGES.Coffee },
  { key: 'P-4', title: 'The smart Toni & Guy haircut', icon: IMAGES.Haircut },
];

// eslint-disable-next-line no-unused-vars
const TEEN_SEA_DATA = [
  { key: 'T-1', title: 'A trip to the movies', icon: IMAGES.MoveTicket },
  { key: 'T-2', title: 'Pizza night with friends', icon: IMAGES.Pizza },
  { key: 'T-3', title: 'A nice japanese notebook', icon: IMAGES.Sketchbook },
  { key: 'T-4', title: 'That new T-Shirt', icon: IMAGES.Shirt },
];


// eslint-disable-next-line no-unused-vars
const PARENT_SEA_DATA = [
  { key: 'P-1', title: 'A Music or video streaming subscription', icon: IMAGES.Netflix },
  { key: 'P-2', title: 'An cab ride to the airport', icon: IMAGES.Uber },
  { key: 'P-3', title: 'Coffee and pancakes at your favourite cafe', icon: IMAGES.Coffee },
  { key: 'P-4', title: 'Two days of fuel', icon: IMAGES.Fuel },
];

export const DATA = {
  [PERSONAS.TEEN]: TEEN_DATA,
  [PERSONAS.PARENT]: PARENT_DATA,
};
